import {
  FieldWrapper,
  InputErrorMessage,
  Label,
  NumberInput,
} from '@commenda/kakashi';
import {
  Controller,
  type Control,
  type FieldValues,
  type Path,
} from 'react-hook-form';

interface OwnershipPercentFieldProps<TForm extends FieldValues> {
  control: Control<TForm>;
  name: Path<TForm>;
  /** Derived from the BE's `percentScale`. */
  step: number;
  errorMessage?: string;
  /** When set, label reads "% owned of <stockClassName>". */
  stockClassName?: string;
}

export const OwnershipPercentField = <TForm extends FieldValues>({
  control,
  name,
  step,
  errorMessage,
  stockClassName,
}: OwnershipPercentFieldProps<TForm>) => (
  <FieldWrapper>
    <Label required>
      {stockClassName ? `% owned of ${stockClassName}` : '% owned'}
    </Label>
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <NumberInput
          value={field.value}
          onChange={field.onChange}
          min={0}
          max={100}
          step={step}
          placeholder="e.g., 10"
          rightEl={() => (
            <span className="txt-small-regular text-text-tertiary pr-md">
              %
            </span>
          )}
        />
      )}
    />
    {errorMessage && <InputErrorMessage message={errorMessage} />}
  </FieldWrapper>
);
